import { NgModule, enableProdMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './component/login/login.component';
import { EmailUpdateComponent } from './component/user/email-update/email-update.component';
import { RegisterComponent } from './component/register/register.component';
import { EmailVerifyComponent } from './component/email-verify/email-verify.component';
import { OtpVerifyComponent } from './component/user/otp-verify/otp-verify.component';
import { ProfileComponent } from './component/profile/profile.component';
import { LogoutComponent } from './component/logout/logout.component';
import { SessionTimeoutComponent } from './component/session-timeout/session-timeout.component';
import { PasswordChangeComponent } from './component/user/password-change/password-change.component';

import { PasswordResetComponent } from './component/password-reset/password-reset.component';
import { PasswordForgotComponent } from './component/password-forgot/password-forgot.component';
import { RoleManagementComponent } from './component/user/role-management/role-management.component';
import { NotAuthorizeComponent } from './component/not-authorize/not-authorize.component';
import { ErrorComponent } from './component/error/error.component';

import { RegistrationSuccessComponent } from './component/register/registration-success/registration-success.component';
import { PasswordChangeSuccessComponent } from './component/user/password-change/password-change-success/password-change-success.component';
import { PasswordResetSuccessComponent } from './component/password-reset/password-reset-success/password-reset-success.component';
import { LogoutSuccessComponent } from './component/logout/logout-success/logout-success.component';
import { CertificateComponent } from './component/certificate/certificate.component';
import { HelpComponent } from './component/help/help.component';
import { environment } from 'src/environments/environment';
import { ReqAuthorizeComponent } from './component/req-authorize/req-authorize.component';
import { ReqAuthorizeSuccessComponent } from './component/req-authorize/req-authorize-success/req-authorize-success.component';
import { ProgressComponent } from './component/progress/progress.component';
import { LowercaseDirective } from './directive/lowercase.directive';
import { InvalidRequestComponent } from './component/invalid-request/invalid-request.component';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { PkiErrorComponent } from './component/pki-error/pki-error.component';
import { PkiLoginComponent } from './component/pki-login/pki-login.component';
import { EmailUpdateSuccessComponent } from './component/user/email-update/email-update-success/email-update-success.component';

import { MyServicesComponent } from './component/user/my-services/my-services.component';
import { NoServicesComponent } from './component/user/no-services/no-services.component';
import { EmailVerifySuccessComponent } from './component/email-verify/email-verify-success/email-verify-success.component';


import { RequestErrorComponent } from './component/error/request-error/request-error.component';
import { ManageRoleMemshipComponent } from './component/admin/manage-role-memship/manage-role-memship.component';
import { SelectUserAccErrComponent } from './component/admin/select-user-acc-err/select-user-acc-err.component';
import { AdminConfirmReqComponent } from './component/admin/admin-confirm-req/admin-confirm-req.component';
import { ReqCompleteSuccessComponent } from './component/admin/req-complete-success/req-complete-success.component';
import { SelectUserAccComponent } from './component/admin/admin-select-user-acc/admin-select-user-acc.component';

import { RoleAdminComponent } from './component/admin/role-admin-search/role-admin.component';
import { AdminAuthFailComponent } from './component/admin/admin-auth-fail/admin-auth-fail.component';
import { ResetWinRegLockComponent } from './component/admin/reset-win-reg-lock/reset-win-reg-lock.component';
import { AdminResetPasswordComponent } from './component/admin/admin-reset-password/reset-password.component';
import { AdminResetPasswordCompleteComponent } from './component/admin/admin-reset-password/reset-password-complete/reset-password-complete.component';
import { SetNewPasswordComponent } from './component/user/set-new-password/set-new-password.component';
import { UpdatedEmailReqComponent } from './component/user/updated-email-req/updated-email-req.component';
import { ManageUserEmailAccessComponent } from './component/admin/manage-user-email-access/manage-user-email-access.component';



export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
  //return new TranslateHttpLoader(http, 'file:///usr/opsbpssecure/i18n/', '.json');
}


if (environment.production) {
  enableProdMode(); //disable all console.log
}

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxGoogleAnalyticsModule.forRoot(environment.googleAnalyticsId),
    NgxGoogleAnalyticsRouterModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    })    
  ],
  declarations: [
    AppComponent,
    LoginComponent,
    ErrorComponent,
    EmailUpdateComponent,
    RegisterComponent,
    RegistrationSuccessComponent,
    LogoutComponent,
    ProfileComponent,
    SessionTimeoutComponent,
    PasswordChangeComponent,
    PasswordChangeSuccessComponent,
    PasswordResetComponent,
    PasswordResetSuccessComponent,
    PasswordForgotComponent,
    OtpVerifyComponent,
    EmailVerifyComponent,
    EmailVerifySuccessComponent,
    RoleManagementComponent,
    NotAuthorizeComponent,
    LogoutSuccessComponent,
    CertificateComponent,
    HelpComponent,
    ReqAuthorizeComponent,
    ReqAuthorizeSuccessComponent,
    ProgressComponent,
    LowercaseDirective,
    InvalidRequestComponent,
    PkiErrorComponent,
    PkiLoginComponent,
    EmailUpdateSuccessComponent,
    PkiLoginComponent,
    MyServicesComponent,

    NoServicesComponent,
    RequestErrorComponent,
    SetNewPasswordComponent,
    UpdatedEmailReqComponent,

    // Admin components
    ManageRoleMemshipComponent,
    SelectUserAccComponent,
    SelectUserAccErrComponent,
    AdminConfirmReqComponent,
    ReqCompleteSuccessComponent,
    RoleAdminComponent,
    AdminAuthFailComponent,
    ResetWinRegLockComponent,
    AdminResetPasswordComponent,
    AdminResetPasswordCompleteComponent,
    ManageUserEmailAccessComponent,
    

  ],
  providers: [TranslateService],
  bootstrap: [AppComponent]
})
export class AppModule { }
